import { createServerFn } from "@tanstack/react-start";
import { getRequestIP } from "@tanstack/react-start/server";
import { z } from "zod";
import { verifyTurnstileToken } from "@/lib/turnstile";

const schema = z.object({
  turnstileToken: z.string().min(1).max(2048),
});

/**
 * Verifies a Turnstile token server-side. Throws on failure.
 * Used as a gate before client-side flows (e.g. supabase.auth.signInWithPassword)
 * where we can't intercept the request itself but want to deter casual bot abuse.
 */
export const verifyTurnstile = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => schema.parse(input))
  .handler(async ({ data }) => {
    const remoteIp = (() => {
      try {
        return getRequestIP({ xForwardedFor: true }) ?? null;
      } catch {
        return null;
      }
    })();
    await verifyTurnstileToken(data.turnstileToken, remoteIp);
    return { ok: true };
  });
